<template>
  <div class="xy-treasure-btn" ref="componentRef"></div>
</template>

<script setup>
import { info, defaultProps } from './config'
import { useTreasure } from '@/packages/components/hook/useTreasure'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const { componentRef, getConfig, getMoneyBalances, getPrizeHistory, joinTreasure } = useTreasure(props)

defineExpose({
  getConfig,
  getMoneyBalances,
  getPrizeHistory,
  joinTreasure
})
</script>

<style lang="scss" scoped>
.xy-treasure-btn {
  position: absolute;
  width: 0px;
  height: 0px;
  display: flex;
  top: -10px;
  left: -10px;
  z-index: -999;
}
</style>
